import ImageProps from "../../types/imageStudio/images";

export const loadImage = (src: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });
};

export const canvasToFile = (canvas: HTMLCanvasElement, filename: string) =>
    new Promise<File>((resolve, reject) => {
        // eslint-disable-next-line no-restricted-syntax -- erzeugt ein internes File-Objekt fuer State/Upload (kein Download), Art. 50 KI-VO nicht einschlaegig
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error("Could not create blob"));
                return;
            }
            resolve(new File([blob], filename, { type: "image/png" }));
        }, "image/png");
});
export const fileToImageProps = (file: File): Promise<ImageProps> =>
    new Promise((resolve, reject) => {
        const src = URL.createObjectURL(file);
        const img = new Image();

        img.onload = () => {
            resolve({
                file,
                src,
                width: img.naturalWidth,
                height: img.naturalHeight,
                timeOfUse: new Date(),
                title: file.name
            });
        };

        img.onerror = reject;
        img.src = src;
    });